/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: tracking.ts
 * Class: tracking.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

export interface TrackingEvent<T> {
  event: string;
  data: T;
}

declare global {
  interface Window {
    // window.google_optimize is a js lib without declared types. So disabling eslint here.
    // https://support.google.com/optimize/answer/9059383?hl=en#zippy=%2Cin-this-article
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    google_optimize: any;
  }
}

export interface UniversalAnalytics {
  transactionId: string;
  transactionAffiliation?: string;
  transactionTotal: number;
  transactionTax?: number;
  transactionProducts?: UniversalAnalyticsProduct[];
  // custom fields
  currencyCode: string;
}

export interface UniversalAnalyticsProduct {
  sku: string;
  name: string;
  category?: string;
  price: number;
  quantity: number;
}

export enum TrackingEventTypes {
  // --- Landingpage Events
  LP_BTN_ORDER_NOW = 'LP.BTN.ORDER-NOW',
  LP_SLOTBOX_SB_LOCATION = 'LP.SLOTBOX.SB.LOCATION',
  LP_SLOTBOX_BTN_ORDER_NOW = 'LP.SLOTBOX.BTN.ORDER-NOW',

  // --- Order Step Three Events
  COS3_BG_PAYMENT_METHOD = 'COS3.BG.PAYMENT-METHOD',
  COS3_CB_TERM_AND_CONDITIONS = 'COS3.CB.TERM-AND-CONDITIONS',
  COS3_CB_SAVE_PAYMENT = 'COS3.CB.SAVE-PAYMENT',
  COS3_BTN_ORDER_NOW = 'COS3.BTN.ORDER-NOW',

  // --- Recharge Modal
  MORA_CB_SAVE_PAYMENT = 'MORA.CB.SAVE-PAYMENT',

  // --- Checkbox Gamecloud Dashboard "extend automatically"
  GCDB_CB_EXTEND_AUTOMATICALLY = 'GCDB.CB.EXTEND-AUTOMATICALLY',

  // --- Order Step One Events
  COS1_TF_SLOTS = 'COS1.TF.SLOTS',
  COS1_SL_SLOTS = 'COS1.SL.SLOTS',
  COS1_BG_DURATION = 'COS1.BG.DURATION',
  COS1_BG_LOCATION = 'COS1.BG.LOCATION',
  COS1_BTN_BUY_NOW_1_CLICK = 'COS1.BTN.BUY-NOW-1-CLICK',
  COS1_BTN_BUY_CONTINUE = 'COS1.BTN.BUY-CONTINUE',
  COS1_LNK_CHANGE_PAYMENT_METHOD = 'COS1.LNK.CHANGE-PAYMENT-METHOD',

  // --- Order Step Three Events
  COS35_BTN_PAY = 'COS35.BTN.PAY',

  // --- Profile Payment Account
  PPP_BTN_PAYMENT_DELETE = 'PPP.BTN.PAYMENT-DELETE',
  PPP_BTN_PAYMENT_SAVE = 'PPP.BTN.PAYMENT-SAVE',

  // --- Save Payment Method Modal
  MOSP_BG_PAYMENT = 'MOSP.BG.PAYMENT',
  MOSP_BTN_CONTINUE = 'MOSP.BTN.CONTINUE'
}
